export const loadCsrfToken = async () => {
  let response = await fetch('/actions/blitz/csrf/token', {method: 'GET'});
  return await response.text();
}
